import { gettext } from '@eventbrite/i18n';
import { SupportedTLD } from '../../components/pricingAndPackagingUtils';

export const QUESTION_ANSWER = [
    {
        question: gettext('What’s included in Eventbrite’s plans?'),
        answer: [
            {
                heading: '',
                text: gettext(
                    'When you host with Eventbrite, your event is on the world’s largest and most trusted events marketplace, \
                    where millions of global ticket buyers find things to do.',
                ),
            },
            {
                heading: '',
                text: gettext(
                    'Regardless of your Eventbrite plan, you can access our full suite of integrated event ticketing and marketing tools. \
                        This includes AI-powered features for efficiently setting up your event listing page, \
                        secure payment collection and processing for your ticket sales, along with powerful social media and email marketing tools. ',
                ),
                linkText: gettext('Learn more about our features.'),
                link: {
                    [SupportedTLD.Canada]:
                        'https://www.eventbrite.ca/organizer/compare-packages/',
                    [SupportedTLD.UnitedKingdom]:
                        'https://www.eventbrite.co.uk/organizer/compare-packages/',
                    [SupportedTLD.Ireland]:
                        'https://www.eventbrite.ie/organizer/compare-packages/',
                    [SupportedTLD.Australia]:
                        'https://www.eventbrite.com.au/organizer/compare-packages/',
                    [SupportedTLD.NewZealand]:
                        'https://www.eventbrite.co.nz/organizer/compare-packages/',
                    [SupportedTLD.UnitedStates]:
                        'https://www.eventbrite.com/organizer/compare-packages/',
                },
            },
        ],
    },
    {
        question: gettext('Do you have a free plan?'),
        answer: [
            {
                heading: '',
                text: gettext(
                    'Yes, publishing events under 25 tickets is free. Additionally,\
                    you can explore Eventbrite Pro with a 14-day trial to test the platform and publish an event before deciding on a paid plan.',
                ),
            },
        ],
    },
    {
        question: gettext('What are Ticketing Fees and Organizer Fees?'),
        answer: [
            {
                heading: gettext('Organizer Fees'),
                text: gettext(
                    'Organizer Fees are associated with publishing events on our platform. For events with 25 tickets or fewer, \
                    it’s free to publish your event. For larger events, you can opt for Flex, \
                    a pay-as-you-publish plan with a one-time fee per event. Alternatively, \
                    there’s Eventbrite Pro, a monthly subscription with added benefits like cost-savings on frequent events \
                    and more daily email marketing sends.',
                ),
            },
            {
                heading: gettext('Ticketing Fees'),
                text: gettext(
                    'Eventbrite charges a Ticketing Fee for each paid ticket and add-on sold, \
                    automatically paid by attendees (although you can choose to absorb them). \
                    The Ticketing Fee comprises a service fee and, where applicable, a payment processing fee. If your tickets are free, \
                    no Ticketing Fees apply. Fees vary by country and currency;',
                ),
                linkText: gettext('Learn more here.'),
                link: {
                    [SupportedTLD.Canada]:
                        'https://www.eventbrite.ca/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                    [SupportedTLD.UnitedKingdom]:
                        'https://www.eventbrite.co.uk/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                    [SupportedTLD.Ireland]:
                        'https://www.eventbrite.ie/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                    [SupportedTLD.Australia]:
                        'https://www.eventbrite.com.au/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                    [SupportedTLD.NewZealand]:
                        'https://www.eventbrite.co.nz/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                    [SupportedTLD.UnitedStates]:
                        'https://www.eventbrite.com/help/en-us/articles/755615/how-much-does-it-cost-for-organizers-to-use-eventbrite/',
                },
            },
        ],
    },
    {
        question: gettext('Do you offer pricing for nonprofits?'),
        answer: [
            {
                heading: '',
                text: gettext('Yes! '),
                linkText: gettext('Learn more here.'),
                link: {
                    [SupportedTLD.Canada]:
                        'https://www.eventbrite.ca/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                    [SupportedTLD.UnitedKingdom]:
                        'https://www.eventbrite.co.uk/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                    [SupportedTLD.Ireland]:
                        'https://www.eventbrite.ie/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                    [SupportedTLD.Australia]:
                        'https://www.eventbrite.com.au/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                    [SupportedTLD.NewZealand]:
                        'https://www.eventbrite.co.nz/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                    [SupportedTLD.UnitedStates]:
                        'https://www.eventbrite.com/help/en-us/articles/585157/can-my-nonprofit-or-charity-get-lower-fees-for-our-events/',
                },
            },
        ],
    },
    {
        question: gettext('What if I need to upgrade or downgrade my plan?'),
        answer: [
            {
                heading: gettext('Flex'),
                text: gettext(
                    'Upgrade anytime if you need to sell more tickets and pay the difference of your new plan. \
                    It’s not possible to downgrade if you sell fewer tickets than you expect. \
                    We recommend starting with the smallest capacity tier you need, and upgrading when you need to sell more.',
                ),
            },
            {
                heading: gettext('Pro'),
                text: gettext(
                    'Pro subscribers can upgrade or downgrade anytime, and future events will follow the capacity limits of your new plan. \
                    If you are hosting a larger event than your plan allows, you can also choose to pay a one-time Flex fee \
                    if you don’t want to upgrade your subscription.',
                ),
            },
        ],
    },
    {
        question: gettext('What if my events are free?'),
        answer: [
            {
                heading: '',
                text: gettext(
                    'If your tickets are free, no Ticketing Fees apply. However, for events over 25 tickets, \
                    you’ll need a paid plan to publish. This also applies to nonprofit organizations. \
                    You can always get started for free and upgrade anytime to sell additional tickets.',
                ),
            },
        ],
    },
];
